import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    DOCTOR_SEND_SMS
} from 'constants/doctors.constants'
import {
  sendSMSResult 
} from "actions/doctors.action";
import { showErrors, stopLoader } from "actions/general.action";
import axios from 'axios'


const sendDoctorSMS = async (payload) => {
    let fd = {id:payload}
    //Have to set api 
    return axios.post("api/v1/super_admin/training_invite", fd)
}

function* doctorSMS({ payload }) {
    try {
        const result = yield call(sendDoctorSMS, payload.id);
        if (result.message) {
            yield put(showErrors(result.message));
        } else {  
            yield all([
                put( sendSMSResult ({id:payload.id,result:result.data})),
                put(stopLoader("Doctor created"))
            ]) 
        }
    } catch (error) {
        if (error.response.data.message != undefined) { 
            yield put(showErrors(error.response.data.message));
        } else {
            yield put(showErrors(error.message));
        }
    }
}

export function* forkFetchSendSMS() {
    yield takeEvery( DOCTOR_SEND_SMS, doctorSMS);
 
}

export default function* rootSaga() {
   
    yield all([
        fork(forkFetchSendSMS),
        
    ]);
}